define.alias("ember-cli-string-helpers/helpers/humanize", "preview-grid/helpers/humanize");